import React from 'react';
import PropTypes from 'prop-types';
import DropDownList from '../../DropDownList';
import TextBox from '../../TextBox';
import normalizeCity from './normalizeCity';
import zipInputMode from './zipInputMode';

const Address = (props) => {
  const {
    countryIsReadonly,
    regionIsReadonly,
    countries,
    regions,
    handleOnChangeCountry,
    country,
    autoCompleteSection,
  } = props;

  // Scopes autofill to one address block so the browser cannot fill the primary
  // applicant's address from the joint applicant's fields, or vice versa.
  const autoCompleteFor = token => (autoCompleteSection ? `${autoCompleteSection} ${token}` : token);

  return (
    <div id="address" className="col col-md-12">
      <DropDownList
        fieldName="country"
        className="form-control"
        label="Country"
        options={countries}
        disabled={countryIsReadonly}
        autoComplete={autoCompleteFor('country')}
        handleChange={() => {
          if (handleOnChangeCountry) {
            handleOnChangeCountry();
          }
        }}
      />
      <TextBox
        name="address1"
        className="form-control"
        label="Street Address 1"
        maxLength={40}
        allowspecialcharacters
        autoComplete={autoCompleteFor('address-line1')}
      />
      <TextBox
        name="address2"
        className="form-control"
        label="Street Address 2"
        maxLength={40}
        allowspecialcharacters
        autoComplete={autoCompleteFor('address-line2')}
      />
      <TextBox
        name="city"
        className="form-control"
        label="City"
        maxLength={30}
        allowspecialcharacters
        normalize={normalizeCity}
        autoComplete={autoCompleteFor('address-level2')}
      />
      <div className="row">
        <div className="col col-md-6 col-xs-7">
          {regions && regions.length > 1 &&
            <DropDownList
              fieldName="region"
              className="form-control"
              label="State or Province"
              options={regions}
              disabled={regionIsReadonly}
              autoComplete={autoCompleteFor('address-level1')}
            />
          }
        </div>
        <div className="col col-md-6 col-xs-5">
          <TextBox
            name="zip"
            className="form-control"
            labelMobile="Zip/Postal"
            label="Zip or Postal Code"
            maxLength={10}
            inputMode={zipInputMode(country)}
            autoComplete={autoCompleteFor('postal-code')}
          />
        </div>
      </div>
    </div>
  );
};

Address.propTypes = {
  countryIsReadonly: PropTypes.bool.isRequired,
  regionIsReadonly: PropTypes.bool.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  regions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  handleOnChangeCountry: PropTypes.func,
  country: PropTypes.string,
  autoCompleteSection: PropTypes.string,
};

export default Address;

